// src/components/EntriesList/utils/apiUtils.js
/**
 * Zentralisierte API-Fetch-Funktion
 */
export async function fetchAPI(url, options = {}, errorMessage = 'Ein Fehler ist aufgetreten.') {
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || errorMessage);
      }
      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw new Error(errorMessage);
    }
  }